export const APP_ID = 'EDP';
export const HOST_ID = 'edp';
export const MYS_MOBILE_PREFIX = '60';
export const AGENT_CODE_INSURANCE = '8OI00003';
export const AGENT_CODE_TAKAFUL = '8OT00003';
export const AGENT_CODE_GAB = 'KEI UAT';
export const BRANCH_CODE = 'BR001';
export const MERCHANT_ID_TAKAFUL = '007700743';
export const MERCHANT_ID_INSURANCE = '007703861';
export const COUNTRY_MALAYSIA = 'MYS';
export const PURPOSE_PROTECTION = '002';
export const MAYBANK_BANK_CODE = '001';
export const RACE_MALAY = '001';
export const MAX_ANB = 16; // ANB (age next birthday)
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const ACCEPT_TYPES = 'image/png,image/jpeg,image/jpg';
export const SOF_OTHERS = '008';
export const REQUIRED_WIDTH = 1350;
export const REQUIRED_HEIGHT = 1080;
export const MAX_COMPRESSED_SIZE = 500 * 1024;
export const I18N_LANGUAGE_EN = 'en';
export const I18N_LANGUAGE_MY = 'my';
export const UAT_GTM = 'GTM-KMCCW2H';
export const PROD_GTM = 'GTM-PDHNZCV';
export const EzyMedical = 'ezy-medical';
export const iMedicalCard = 'iMedical-card-elite';
export const ProductLabel: {
  [productType: string]: string;
} = {
  [EzyMedical]: 'EzyMedical',
  [iMedicalCard]: 'i-Medical Card',
};

// Destination for the post-decline "View Product" CTA. Per UAT v1.1 #1,
// customers who fail the health declaration should land on the generic
// health-products listing (so they can browse alternatives) rather than
// the same product they were just declined for.
export const ProductLandingUrl: {
  [productType: string]: { en: string; ms: string };
} = {
  [EzyMedical]: {
    en: 'https://www.etiqa.com.my/health',
    ms: 'https://www.etiqa.com.my/kesihatan',
  },
  [iMedicalCard]: {
    en: 'https://www.etiqa.com.my/health',
    ms: 'https://www.etiqa.com.my/kesihatan',
  },
};
export const CURRENCY = 'MYR';
export const TAKAFUL = 'takaful';
export const ENTITY_CODE_TAKAFUL = 'EFTB';
export const INSURANCE = 'insurance';
export const ENTITY_CODE_INSURANCE = 'ELIB';
export const ENCRYPTION_CONFIG = {
  key: 'Ease_LifeFamily_IDNos_Secret_123',
  passphrase: 'Ease.IDNo:secret01234',
};
